export var dataHooks = {
  line: 'skeleton-line',
  chunk: 'skeleton-chunk'
};